import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, LogIn, Search } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import APP_CONFIG from '../config/appConfig';
import { ui } from './ui/styles';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (!formData.username || !formData.password) {
        setError('Por favor, preencha todos os campos');
        return;
      }

      const result = await login(formData.username, formData.password);

      if (result.success) {
        navigate('/');
      } else {
        setError(result.error || 'Usuário ou senha incorretos');
      }
    } catch (err) {
      console.error('Erro na requisição:', err);
      setError('Erro de conexão com o servidor. Verifique se a API está rodando.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen w-full items-center justify-center bg-slate-900 px-4 py-8">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_80%,rgba(37,99,235,0.25),transparent_50%),radial-gradient(circle_at_80%_20%,rgba(59,130,246,0.2),transparent_50%)]" />

      <div className="relative w-full max-w-md overflow-hidden rounded-2xl border border-white/10 bg-white shadow-2xl">
        <div className="border-b border-border bg-slate-50 px-8 py-8 text-center">
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo.svg`}
            alt="Logo"
            className="mx-auto mb-4 h-16 w-auto"
          />
          <h2 className="text-xl font-semibold tracking-tight text-text">
            {APP_CONFIG.MUNICIPALITY_NAME}
          </h2>
          <p className="mt-1 text-sm text-muted">{APP_CONFIG.APP_NAME}</p>
        </div>

        <form className="space-y-5 px-8 py-8" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="username" className={ui.label}>
              Usuário
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleInputChange}
              className={ui.input}
              placeholder="Digite seu usuário"
              required
            />
          </div>

          <div>
            <label htmlFor="password" className={ui.label}>
              Senha
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className={ui.input}
              placeholder="••••••••"
              required
            />
          </div>

          {error && (
            <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}

          <button
            type="submit"
            className={`${ui.btnPrimary} w-full`}
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                Entrando...
              </>
            ) : (
              <>
                <LogIn size={16} />
                Entrar
              </>
            )}
          </button>

          <button
            type="button"
            className={`${ui.btn} w-full`}
            onClick={() => navigate('/consulta')}
          >
            <Search size={16} />
            Prosseguir para consulta
          </button>
        </form>

        <div className="border-t border-border bg-slate-50 px-8 py-4 text-center">
          <p className="text-xs text-muted">
            Desenvolvido por <strong className="text-text">{APP_CONFIG.FOOTER_TEXT}</strong> | 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
